import { render, staticRenderFns } from "./DialogShindansyo.vue?vue&type=template&id=608ff04c&scoped=true"
import script from "./DialogShindansyo.vue?vue&type=script&lang=js"
export * from "./DialogShindansyo.vue?vue&type=script&lang=js"
import style0 from "./DialogShindansyo.vue?vue&type=style&index=0&id=608ff04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ff04c",
  null
  
)

export default component.exports